import React, { useContext } from "react";
import "./style.css";
import Rating from "@mui/material/Rating";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faHeart } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { IoEye } from "react-icons/io5";

import { postData } from "../../utils/api";
import { MyContext } from "../../App";

const Products = ({ item, tag }) => {
  const { refreshWatchlist, setAlertBox } = useContext(MyContext);

  if (!item) return null;

  const productId = item._id || item.id;
  const productName = item.name || "Unnamed Product";
  const productDescription = item.description || "No description available.";
  const productImage =
    (item.images && item.images[0]) || "/default-product.jpg";

  const getUserId = () => {
    try {
      const userStr = localStorage.getItem("user");
      const tokenStr = localStorage.getItem("token");



      if (!userStr) {
        return null;
      }

      if (!tokenStr) {
        return null;
      }

      const user = JSON.parse(userStr);
      const userId = user?._id || user?.id || user?.userId;

      if (!userId) return null;

      return userId;
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      return null;
    }
  };

  const addToWatchlist = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const userId = getUserId();
    const token = localStorage.getItem("token");

    if (!userId || !token) {
      setAlertBox({
        open: true,
        error: true,
        msg: "Please log in to add items to your wishlist.",
      });
      return;
    }

    try {
      const watchlistData = {
        productTitle: productName,
        images: item.images || [productImage],
        rating: parseFloat(item.rating) || 0,
        price: item.price,
        productId: productId,
        userId: userId,
        brand: item.brand || "N/A",
        oldPrice: item.oldPrice || null,
      };

      const response = await postData("/api/watchlist/add", watchlistData);

      if (response && (response.success || response.status === 'success')) {
        setAlertBox({
          open: true,
          error: false,
          msg: "Item added to wishlist successfully!"
        });

        if (refreshWatchlist) refreshWatchlist();
      } else {
        throw new Error(response.message || response.msg || "Failed to add to wishlist");
      }
    } catch (error) {
      let errorMessage = "Could not connect to the server.";
      if (error.response?.data?.message) errorMessage = error.response.data.message;
      else if (error.response?.data?.msg) errorMessage = error.response.data.msg;
      else if (error.message) errorMessage = error.message;

      setAlertBox({
        open: true,
        error: true,
        msg: errorMessage.toLowerCase().includes("already") ? "Item is already in your wishlist!" : errorMessage
      });
    }
  };

  return (
    <div className="productThumb">
      {tag && <span className={`badge ${tag}`}>{tag}</span>}

      <div className="img-container position-relative">
        <Link to={`/details/${productId}`}>
          <div className="imgWrapper">
            <img src={productImage} className="w-100" alt={productName} />
          </div>
        </Link>
        <div className="overlay">
          <Tooltip title="Add to wishlist" arrow>
            <button className="overlay-button" onClick={addToWatchlist}>
              <FontAwesomeIcon icon={faHeart} />
            </button>
          </Tooltip>
          <Tooltip title="Quick view" arrow>
            <Link to={`/details/${productId}`}>
              <button className="overlay-button">
                <IoEye size={18} color="#fff" />
              </button>
            </Link>
          </Tooltip>
        </div>
      </div>

      <div className="info">
        <h4 className="title">
          <Link to={`/details/${productId}`}>
            {productName.length > 20
              ? productName.slice(0, 20) + "..."
              : productName}
          </Link>
        </h4>
        <p className="description">
          {productDescription.length > 42
            ? productDescription.slice(0, 82) + "..."
            : productDescription}
        </p>
        <Rating
          name="half-rating-read"
          value={parseFloat(item.rating) || 0}
          precision={0.5}
          readOnly
        />
        <span className="brand text-g">
          By <span className="text-g">{item.brand}</span>
        </span>
        <div className="d-flex align-items-center mt-3">
          <div className="d-flex align-items-center">
            <span className="price text-g font-weight-bold">₹{item.price}</span>
            {item.oldPrice && (
              <span className="oldPrice">₹{item.oldPrice}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;